import React from "react";
import { StringProcessor } from "@utils/stringProcessor";

const natoRequired = ["street", "city", "firstname", "lastname", "email", "businessname", "postcode"]

const isNatoRequired = (inputName: string) => natoRequired.includes(inputName.toLowerCase())

const useNato = (inputName: string, input: string) => {
    const [nato, setNato] = React.useState("")
    React.useEffect(() => {
        isNatoRequired(inputName) && setNato(StringProcessor.natoPhoneticString(input))
    }, [input, inputName])
    return nato
}

export default useNato